<template>
  <div class="content_box contact">
    <Header @onSearch="onSearch" style="background: #8e86dd">
      <!-- 工具栏 -->
      <Tollbar
        class="header_menu_box"
        :list="tollbarList"
        :moreTool="moreToolbarList"
        type="1"
        theme="1"
        :selectList="selectList"
        :isShowSearch.sync="isShowSearch"
        :isShowSelect.sync="isShowSelect"
        @menuClick="menuClick"
      ></Tollbar>
    </Header>
    <div class="content_wrap detail">
      <div class="detail_header">
        <div class="detail_header_info">
          <div class="detail_header_info_name">
            <OverflowTooltip
              :tip="companyInfo == null ? '' : companyInfo?.base?.companyName"
            />
            <i
              v-if="companyInfo?.base?.collectIds != '-'"
              class="iconfont icon-shoucang active"
            ></i>
          </div>
          <div
            class="detail_header_info_address"
            v-if="
              companyInfo?.base?.durant != '-' || companyInfo?.base?.city != '-'
            "
          >
            <img :src="companyInfo?.base?.img" />
            <div class="detail_header_info_address_txt">
              <span v-if="companyInfo?.base?.durant != '-'">{{
                companyInfo?.base?.durant
              }}</span
              ><span
                v-if="
                  companyInfo?.base?.city != '-' &&
                  companyInfo?.base?.durant != '-'
                "
                >&nbsp;,&nbsp;</span
              ><span v-if="companyInfo?.base?.city != '-'">{{
                companyInfo?.base?.city
              }}</span>
              <span v-if="companyInfo?.base?.province != '-'"
                >, {{ companyInfo?.base?.province }}</span
              >
              <span v-if="companyInfo?.base?.country != '-'"
                >, {{ companyInfo?.base?.country }}</span
              >
            </div>
          </div>

          <el-tabs class="detail_header_info_label" v-model="activeLabelTab">
            <el-tab-pane
              :key="index"
              v-for="(item, index) in labelList"
              :name="item.labelCode"
              :disabled="true"
            >
              <template #label>
                <div class="tabsClass" :class="item.labelClass">
                  <span>{{ item.label }}</span>
                </div>
              </template>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="detail_header_dqi">
          <!-- echart -->
          <div class="new-content-top-right">
            <div class="new-content-right-company">
              <div ref="companyRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CompanyDQI") }}
                <el-tooltip
                  class="item"
                  popper-class="detail-dqi-tips"
                  effect="light"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CompanyDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CompanyTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc2") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CompanyDQIdesc3") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="new-content-right-country">
              <div ref="countryRef" class="new-content-right-echart"></div>
              <div class="new-content-right-title">
                {{ $t("Snapshot.CountryDQI") }}
                <el-tooltip
                  class="item"
                  popper-class="detail-dqi-tips"
                  effect="light"
                  placement="bottom"
                >
                  <div slot="content">
                    <div class="detail-dqi-tips-header">
                      {{ $t("Snapshot.CountryDQI") }}
                    </div>
                    <div class="detail-dqi-tips-desc detail-dqi-tips-sub-desc">
                      {{ $t("Snapshot.CountryTitle") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc1") }}
                    </div>
                    <div class="detail-dqi-tips-desc">
                      {{ $t("Snapshot.CountryDQIdesc2") }}
                    </div>
                  </div>
                  <i class="iconfont icon-gantanhao1"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail_content">
        <div class="detail_content_tab">
          <div
            class="detail_tab_item"
            :class="{ active: activeTab == tabItem.type }"
            v-for="tabItem in detailTabs"
            :key="tabItem.type"
            @click="changeTab(tabItem.type)"
          >
            {{ tabItem.name }}
          </div>
        </div>
        <div class="detail_content_tab_content">
          <ContactInfo
            class="detail_content_tab_con_echart"
            v-if="activeTab == '1'"
            :isShowSearch="isShowSearch"
            :isShowSelect="isShowSelect"
            :detailInfo="companyInfo"
            @onSendEmail="onSendEmail"
            @onBatch="onBatch"
            @onAddCus="onAddCus"
            @onAi="onAi"
          />
          <OrgStructure
            class="detail_content_tab_con_echart"
            @onSendEmail="onSendEmail"
            @onBatch="onBatch"
            @onAddCus="onAddCus"
            @onAi="onAi"
            v-if="activeTab == '2'"
          />
        </div>
      </div>
    </div>
    <!-- 认证-->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="batchDialogVisible"
      :before-close="
        () => {
          batchDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_1000"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/batch_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("SearchLeadsContact.InformationAuthentication") }}
        </div>
        <div class="dialog_content_body">
          <div class="batch_title">
            {{ $t("SearchLeadsContact.AuthenticationMethod") }}:
          </div>

          <el-radio label="1" v-model="batchChosen">{{
            $t("SearchLeadsContact.Iwanttoclaimit")
          }}</el-radio>
          <div class="radio_tips">
            {{ $t("SearchLeadsContact.IwanttoclaimitMessage") }}
          </div>
          <el-radio label="2" v-model="batchChosen">{{
            $t("SearchLeadsContact.AuthenticationService")
          }}</el-radio>
          <div class="radio_tips">
            {{ $t("SearchLeadsContact.AuthenticationServiceMessage") }}
          </div>
          <el-radio label="3" v-model="batchChosen">{{
            $t("SearchLeadsContact.UploadedList")
          }}</el-radio>
          <div class="radio_tips">
            <el-button type="text">{{
              $t("SearchLeadsContact.DownloadTemplate")
            }}</el-button>
            <el-button type="text" @click="openUpload">{{
              $t("SearchLeadsContact.Upload")
            }}</el-button>
          </div>
          <div class="batch_title">
            {{ $t("SearchLeadsContact.ListofCertifiedPersonnel") }}
          </div>
          <el-table
            class="risk_table"
            :data="tableData"
            height="100%"
            ref="tableRef"
            row-key="aaaId"
          >
            <el-table-column
              prop="name"
              :label="$t('SearchLeadsContact.Name')"
              min-width="200"
            >
              <template slot-scope="scope">
                <div class="flex_center_start_box">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="position"
              align="center"
              :label="$t('SearchLeadsContact.Position')"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="country"
              align="center"
              :label="$t('SearchLeadsContact.Country')"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="email"
              align="center"
              :label="$t('SearchLeadsContact.Email')"
              min-width="170"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.email }}
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="" min-width="70">
              <template slot-scope="scope">
                <i slot="reference" class="iconfont icon-shanchu" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog_footer">
          <!-- <el-button
            @click="batchDialogVisible = false"
            class="risk_cancel_btn"
            type="cancel"
            >{{ $t("SearchLeadsContact.Cancel") }}</el-button
          > -->
          <el-button
            @click="batchDialogVisible = false"
            class="risk_primary_btn"
            type="primary"
            >{{ $t("SearchLeadsContact.Submit") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 邮件 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="emailDialogVisible"
      :before-close="
        () => {
          emailDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_1000"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/email_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("SearchLeadsContact.EmailSending") }}
        </div>
        <div class="dialog_content_body">
          <div class="batch_title">
            {{ $t("SearchLeadsContact.RecipientInformation") }}:
          </div>
          <div class="tree_select_box">
            <div class="tree_select">
              <div class="tree_select_input">
                <el-input
                  prefix-icon="el-icon-search"
                  v-model="treeSearchVal"
                  :placeholder="$t('SearchLeadsContact.Pleaseenteryourname')"
                />
              </div>
              <div class="tree_select_content">
                <div class="tree_select_content_left">
                  <ul>
                    <li
                      @click="chosenGroup(item)"
                      v-for="item in treeData"
                      :key="item.index"
                      :class="item.isChosen ? 'active' : ''"
                    >
                      <OverflowTooltip :tip="item.groupName" />
                      <i class="iconfont icon-jiantouyou" />
                    </li>
                  </ul>
                </div>
                <div class="tree_select_content_right">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                    >{{ $t("SearchLeadsContact.All") }}</el-checkbox
                  >

                  <el-checkbox
                    v-model="list.ischeck"
                    @change="handleCheckedChange"
                    v-for="list in treeData.filter(
                      (item) => item.isChosen == true,
                    )[0]?.children"
                    :label="list.id"
                    :key="list.index"
                    >{{ list.name }}</el-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="tree_selected">
              <div class="tree_selected_title">
                {{ $t("SearchLeadsContact.SelectedList") }}
              </div>
              <ul>
                <li v-for="item in checkSelect" :key="item.index">
                  <OverflowTooltip :tip="item.name" />
                  <i class="iconfont icon-cuowu" @click="delChosen(item)" />
                </li>
              </ul>
            </div>
          </div>
          <div class="batch_title">
            {{ $t("SearchLeadsContact.SenderInformation") }}:
          </div>
          <el-form :model="emailForm" :rules="emailFormRules" ref="emailForm">
            <el-form-item
              prop="companyName"
              required
              :label="$t('SearchLeadsContact.CompanyName') + ':'"
            >
              <el-input
                v-model="emailForm.companyName"
                :placeholder="$t('SearchLeadsContact.EnterCompanyName')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="name"
              required
              :label="$t('SearchLeadsContact.Name') + ':'"
            >
              <el-input
                v-model="emailForm.name"
                :placeholder="$t('SearchLeadsContact.EnterName')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="depart"
              required
              :label="$t('SearchLeadsContact.Department') + ':'"
            >
              <el-input
                v-model="emailForm.depart"
                :placeholder="$t('SearchLeadsContact.EnterDepartment')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="postion"
              required
              :label="$t('SearchLeadsContact.Position') + ':'"
            >
              <el-input
                v-model="emailForm.postion"
                :placeholder="$t('SearchLeadsContact.EnterPosition')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="email"
              required
              :label="$t('SearchLeadsContact.Email') + ':'"
            >
              <el-input
                v-model="emailForm.email"
                :placeholder="$t('SearchLeadsContact.EnterEmail')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="phone"
              required
              :label="$t('SearchLeadsContact.Phone') + ':'"
            >
              <el-input
                v-model="emailForm.phone"
                :placeholder="$t('SearchLeadsContact.EnterPhone')"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="content"
              class="row"
              required
              :label="$t('SearchLeadsContact.EmailContent') + ':'"
            >
              <el-input
                v-model="emailForm.content"
                type="textarea"
                :placeholder="$t('SearchLeadsContact.Pleaseenteremailcontent')"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog_footer">
          <!-- <el-button
            @click="emailDialogVisible = false"
            class="risk_cancel_btn"
            type="cancel"
            >{{ $t("SearchLeadsContact.Cancel") }}</el-button
          > -->
          <el-button
            @click="emailConfirm"
            class="risk_primary_btn"
            type="primary"
            >{{ $t("SearchLeadsContact.Submit") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 邮件确认 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="emailConfirmDialogVisible"
      :before-close="
        () => {
          emailConfirmDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_1000"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/email_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("SearchLeadsContact.EmailConfirmationMessage") }}
        </div>
        <div class="dialog_content_body">
          <div class="batch_title">
            {{ $t("SearchLeadsContact.Hellodearuser") }}:
          </div>
          <div class="risk_desc">
            {{ $t("SearchLeadsContact.Message") }}
          </div>
          <div class="email_confirm_box">
            <div class="batch_title">
              {{ $t("SearchLeadsContact.RecipientInformation") }}:
            </div>
            <ul class="email_confirm_box_chosen">
              <li v-for="item in checkSelect" :key="item.index">
                <OverflowTooltip :tip="item.name" />
              </li>
            </ul>
          </div>
          <div class="email_confirm_box">
            <div class="batch_title">
              {{ $t("SearchLeadsContact.SenderInformation") }}:
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.CompanyName") }}:{{
                emailForm.companyName
              }}
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.Name") }}:{{ emailForm.name }}
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.Department") }}:{{ emailForm.depart }}
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.Position") }}:{{ emailForm.postion }}
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.Email") }}:{{ emailForm.email }}
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.Phone") }}:{{ emailForm.phone }}
            </div>
            <div class="email_confirm_box_form">
              {{ $t("SearchLeadsContact.EmailContent") }}:{{
                emailForm.content
              }}
            </div>
          </div>
          <div class="batch_title">
            {{
              $t("SearchLeadsContact.CSIWebsite")
            }}:https://www.csibizsearch.com/
          </div>
          <div class="batch_title">
            {{
              $t("SearchLeadsContact.CSICustomerServiceEmail")
            }}:services@csibizsearch.com
          </div>
        </div>
        <div slot="footer" class="dialog_footer">
          <!-- <el-button
            @click="emailDialogVisible = false"
            class="risk_cancel_btn"
            type="cancel"
            >{{ $t("SearchLeadsContact.Cancel") }}</el-button
          > -->
          <el-button
            @click="
              (emailConfirmDialogVisible = false), (emailDialogVisible = true)
            "
            class="risk_primary_btn"
            type="primary"
            >{{ $t("SearchLeadsContact.Return") }}</el-button
          >
          <el-button
            @click="emailConfirmDialogVisible == false"
            class="risk_primary_btn"
            type="primary"
            >{{ $t("SearchLeadsContact.Submit") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="addlDialogVisible"
      :before-close="
        () => {
          addlDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_1000"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/cus_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("SearchLeadsContact.Addcustomerconfirmationlist") }}
        </div>
        <div class="dialog_content_body">
          <div class="risk_desc">
            {{ $t("SearchLeadsContact.AddCustomersMessage") }}
          </div>
          <div class="batch_title">
            {{ $t("SearchLeadsContact.ListofCertifiedPersonnel") }}
          </div>
          <el-table
            class="risk_table"
            :data="tableData"
            height="100%"
            ref="tableRef"
            row-key="aaaId"
          >
            <el-table-column
              prop="name"
              :label="$t('SearchLeadsContact.Name')"
              min-width="200"
            >
              <template slot-scope="scope">
                <div class="flex_center_start_box">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="position"
              align="center"
              :label="$t('SearchLeadsContact.Position')"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="country"
              align="center"
              :label="$t('SearchLeadsContact.Country')"
              min-width="120"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="email"
              align="center"
              :label="$t('SearchLeadsContact.Email')"
              min-width="170"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                {{ scope.row.email }}
              </template>
            </el-table-column>
            <el-table-column prop="" align="center" label="" min-width="70">
              <template slot-scope="scope">
                <i slot="reference" class="iconfont icon-shanchu" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog_footer">
          <!-- <el-button
            @click="addlDialogVisible = false"
            class="risk_cancel_btn"
            type="cancel"
            >{{ $t("SearchLeadsContact.Cancel") }}</el-button
          > -->
          <el-button
            @click="addlDialogVisible = false"
            class="risk_primary_btn"
            type="primary"
            >{{ $t("SearchLeadsContact.Submit") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- ai -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="aiDialogVisible"
      :before-close="
        () => {
          aiDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_800"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/ai_icon.png" />
        </div>
        <div class="dialog_title_img_text">
          {{ $t("SearchLeadsContact.AIEmailAssistantTitle") }}
        </div>
        <div class="risk_desc">
          {{ $t("SearchLeadsContact.AIEmailAssistantMessage") }}
        </div>
      </div>
      <!-- <div slot="footer" class="dialog_footer">
        <el-button
          class="risk_primary_btn"
          type="primary"
          @click="aiDialogVisible = false"
          >{{ $t("SearchLeadsContact.Close") }}</el-button
        >
      </div> -->
    </el-dialog>
    <!-- 上传 -->
    <UpdateFile
      :isUploaded="true"
      :pageType="'leads'"
      :UpdateFileDialog="UpdateFileDialog"
      @closeUpDownDialog="onCloseUpDownDialog"
      @uploadSuccess="onUploadSuccess"
    ></UpdateFile>
  </div>
</template>

<script>
import { mixins1 } from "@/mixins/index";
import * as echarts from "echarts/core";
import Page from "@/views/newLayout/page.vue";
import TabIcon from "@/views/newLayout/tabIcon.vue";
import Header from "@/views/newLayout/header.vue";
import Tollbar from "@/views/newLayout/tollbar.vue";
import ContactInfo from "./detail_contactInfo.vue";
import OrgStructure from "./detail_orgStructure.vue";
import UpdateFile from "../myAccount/Database/adCppany/UpdateFile.vue";
import {
  getSanctionDateSanction,
  getSanctionProfileNotes,
  getSanctionDetailSource,
  getSanctionRelateInfo,
} from "@/api/newApi.js";
import { getCompanySnap, getCompanyProfile } from "@/api/companyApi";

export default {
  name: "UboDetail",
  mixins: [mixins1],
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= 0.5) {
            binding.value(); // 执行绑定的函数
          }
        });
      },
    },
  },
  computed: {
    activeTab() {
      return Number(this.$route.query.type || 1);
    },
    tollbarList() {
      return [
        {
          icon: "icon-youhua",
          name: this.$t("Toolbar.Optimize"),
          disabled: false,
        },
        {
          icon: "icon-xuanze",
          name: this.$t("Toolbar.Select"),
          disabled: false,
        },
        {
          icon: "icon-bianji1",
          name: this.$t("Toolbar.Edit"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-filter",
          name: this.$t("Toolbar.Sortby"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-shoucang1",
          name: this.$t("Toolbar.Collect"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-baocun",
          name: this.$t("Toolbar.Saved"),
          disabled: true,
          select: true,
        },
        {
          icon: "icon-icon_xinyong_xianxing_jijin-307",
          name: this.$t("Toolbar.Compare"),
          disabled: true,
        },
        {
          icon: "icon-daochu04",
          name: this.$t("Toolbar.Export"),
          disabled: true,
        },
        {
          icon: "icon-xiazai",
          name: this.$t("Toolbar.Download"),
          disabled: true,
        },
        {
          icon: "icon-shuaxin",
          name: this.$t("Toolbar.Update"),
          disabled: true,
        },
        {
          icon: "icon-judan",
          name: this.$t("Toolbar.Reporterror"),
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: this.$t("Toolbar.RiskScanning"),
          disabled: true,
        },
      ];
    },
    moreToolbarList() {
      return [
        {
          icon: "icon-xinyongpingjia",
          name: this.$t("Toolbar.CreditAssessment"),
          disabled: true,
        },
        {
          icon: "icon-shujufenxi1",
          name: this.$t("Toolbar.DataAnalysis"),
          disabled: true,
        },
        {
          icon: "icon-touzizuhe",
          name: this.$t("Toolbar.NewPortfolio"),
          disabled: true,
        },
        {
          icon: "icon-dayin-dayinji",
          name: this.$t("Toolbar.Print"),
          disabled: true,
        },
        {
          icon: "icon-gudong",
          name: this.$t("Toolbar.Share"),
          disabled: true,
        },
      ];
    },
  },
  components: {
    Header,
    Tollbar,
    Page,
    TabIcon,
    ContactInfo,
    OrgStructure,
    UpdateFile,
  },
  data() {
    return {
      batchDialogVisible: false,
      aiDialogVisible: false,
      emailDialogVisible: false,
      emailConfirmDialogVisible: false,
      addlDialogVisible: false,
      UpdateFileDialog: false,
      batchChosen: "1",

      treeSearchVal: "",
      isIndeterminate: false,
      checkAll: false,
      checkedDepart: [],

      emailForm: {
        companyName: "",
        name: "",
        depart: "",
        postion: "",
        email: "",
        phone: "",
        content: "",
      },
      emailFormRules: {},

      checkSelect: [],
      treeData: [
        {
          id: "1",
          groupName: "Administration Department",
          isChosen: true,
          children: [
            { id: "1_1", name: "Albert A. Gore Jr.", ischeck: false },
            { id: "1_2", name: "Alex Gorsky", ischeck: false },
            { id: "1_3", name: "Andrea Jung", ischeck: false },
            { id: "1_4", name: "Arthur D. Levinson", ischeck: false },
            { id: "1_5", name: "Deirdre O'Brien", ischeck: false },
            { id: "1_6", name: "AEddy Cue", ischeck: false },
            { id: "1_7", name: "James A. Bell", ischeck: false },
            { id: "1_8", name: "Jeff Williams", ischeck: false },
            { id: "1_9", name: "Andrea Jung", ischeck: false },
            { id: "1_10", name: "Alex Gorsky", ischeck: false },
            { id: "1_11", name: "Andrea Jung", ischeck: false },
          ],
        },
        {
          id: "2",
          groupName: "Marketing Department",
          isChosen: false,
          children: [
            { id: "2_1", name: "Albert  Jr.", ischeck: false },
            { id: "2_2", name: "Alex ", ischeck: false },
            { id: "2_3", name: " Jung", ischeck: false },
            { id: "2_4", name: " D. Levinson", ischeck: false },
            { id: "2_5", name: "Deirdre O'", ischeck: false },
            { id: "2_6", name: "AEddy ", ischeck: false },
            { id: "2_7", name: "James A. Bell", ischeck: false },
            { id: "2_8", name: "Jeff ", ischeck: false },
            { id: "2_9", name: "Andrea ", ischeck: false },
            { id: "2_10", name: "Alex ", ischeck: false },
            { id: "2_11", name: "Andrea ", ischeck: false },
          ],
        },
        {
          id: "3",
          groupName: "Development Departme",
          isChosen: false,
          children: [
            { id: "3_1", name: "Albert  Jr.", ischeck: false },
            { id: "3_2", name: "Alex ", ischeck: false },
          ],
        },
      ],
      tableData: [
        {
          aaaId: "1",
          name: "Albert A. Gore Jr.",
          position: "CEO",
          country: "China",
          email: "svdvvbaa@apple.com",
        },
        {
          aaaId: "2",
          name: "Andrea Jung",
          position: "CEO",
          country: "United States",
          email: "3sssssss@apple.com",
        },
        {
          aaaId: "3",
          name: "Eddy Cue",
          position: "CEO",
          country: "United States",
          email: "sggggggg@apple.com",
        },
      ],
      activeLabelTab: "",
      // activeTab: this.$route.query.tab || "1",
      detailTabs: [
        { name: this.$t("SearchLeadsContact.ContactInformation"), type: "1" },
        {
          name: this.$t("SearchLeadsContact.OrganizationalFramework"),
          type: "2",
        },
      ],

      companyInfo: {}, //公司信息
      labelList: [],
      radiusX1: 48,
      radiusX2: 62,
      fontSize: 26,
      lineHeight: 28,
      py: "55%",
      companyDQI: 0, //公司值
      countryDQI: 0, //国家值
      companyChart: null,
      countryChart: null,
      //   工具栏
      isShowSearch: true, //默认展示侧边检索
      isShowSelect: false, // 是否显示复选框
      selectList: [],
    };
  },
  methods: {
    // 搜索
    // 工具栏点击
    onSearch(params, type) {
      // 如果 query 完全一致，直接 return
      let routeData = this.$router.resolve({
        path: "/ubo/list",
        query: {
          keyword: params.searchKeyword,
          selectKey: type,
        },
      });

      window.open(routeData.href, "_blank");
    },
    // 公司信息
    async getCompanyInfo() {
      let res = await getCompanySnap({
        id3a: this.$route.query.id3a,
      });
      if (res.code == 200) {
        this.companyInfo = res.data;
        document.title = this.companyInfo?.base?.companyName;
        let countryImg = this.getCountryImgUrl(res.data?.base?.countryFlag);
        this.companyInfo.base.img = require("../../../static" + countryImg);
        localStorage.setItem("CompanyBase", JSON.stringify(res.data));
        this.labelList = res.data.labels;
        this.labelList = this.labelList.sort((a, b) => {
          const codeA = a.labelCode;
          const codeB = b.labelCode;

          const firstLetterA = codeA.charAt(0);
          const firstLetterB = codeB.charAt(0);

          const priority = {
            P: 3,
            F: 2,
          };

          const priorityA = priority[firstLetterA] || 1;
          const priorityB = priority[firstLetterB] || 1;

          if (priorityA !== priorityB) {
            return priorityA - priorityB;
          }

          if (firstLetterA !== firstLetterB) {
            return firstLetterA.localeCompare(firstLetterB);
          }

          const numA = parseInt(codeA.substring(1));
          const numB = parseInt(codeB.substring(1));
          return numA - numB;
        });
        this.labelList = this.labelList.map((item) => ({
          ...item,
          labelClass:
            item.labelCode && item.labelCode.charAt(0).toUpperCase() === "P"
              ? "purplePane"
              : item.labelCode.charAt(0).toUpperCase() === "F"
              ? "bluePane"
              : "greenPane",
        }));
        //   公司DQIecahrts
        this.companyDQI =
          res.data.base.companyDQI != "n.a." && res.data.base.companyDQI != "-"
            ? parseInt(res.data.base.companyDQI)
            : 0;
        this.initCompanyEchart();
        // 国家DQIecharts
        this.countryDQI =
          res.data.base.countryDQI && res.data.base.countryDQI != "-"
            ? parseInt(res.data.base.countryDQI)
            : 0;
        this.initCountryEchart();
      }
    },
    // 公司echarts
    initCompanyEchart() {
      this.companyChart = echarts.init(this.$refs.companyRef);
      let data = this.companyDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From Back",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true,
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: 5,
                },
              },
            ],
          },
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 180 - 180 * (data / 100),
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: 5,
                },
              },
            ],
          },
        ],
      };
      this.companyChart.setOption(option);
    },
    // 国家echarts
    initCountryEchart() {
      this.countryChart = echarts.init(this.$refs.countryRef);
      let data = this.countryDQI;
      let option = {
        title: {
          text: data,
          x: "center",
          y: this.py,
          textStyle: {
            lineHeight: this.lineHeight,
            fontFamily: "Arial Bold",
            fontSize: this.fontSize,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "Access From Back",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 360,
            label: {
              show: false,
            },
            emphasis: {
              disabled: true,
            },
            data: [
              {
                value: 100,
                itemStyle: {
                  color: "#ffffff",
                  borderRadius: 5,
                },
              },
            ],
          },
          {
            name: "Access From",
            type: "pie",
            radius: [this.radiusX1, this.radiusX2],
            center: ["50%", "100%"],
            startAngle: 180,
            endAngle: 180 - 180 * (data / 100),
            label: {
              show: false,
            },
            emphasis: {
              disabled: true, // 关闭高亮（hover 时不变色）
            },
            data: [
              {
                value: data,
                itemStyle: {
                  color:
                    data < 50 ? "#F00000" : data < 76 ? "#FFC000" : "#00c924",
                  borderRadius: 5,
                },
              },
            ],
          },
        ],
      };
      this.countryChart.setOption(option);
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.companyChart) {
        this.companyChart.resize();
      }
      if (this.countryChart) {
        this.countryChart.resize();
      }
    },
    handleResize() {
      if (window.innerWidth > 1920) {
        // 大屏幕
        this.radiusX1 = 48;
        this.radiusX2 = 62;
        this.fontSize = 26;
        this.lineHeight = 28;
        this.py = "55%";
      } else {
        this.radiusX1 = 32;
        this.radiusX2 = 41;
        this.fontSize = 16;
        this.lineHeight = 18;
        this.py = "52%";
      }
      this.initCompanyEchart();
      this.initCountryEchart();
      this.resizeChart();
    },

    changeTab(index) {
      if (String(this.$route.query.type) === String(index)) return;
      this.isShowInquiry = false;
      // this.activeTab = index;
      this.$router.replace({
        path: "/leads/contact",
        query: {
          id3a: this.$route.query.id3a,
          keyword: this.$route.query.keyword,
          selectKey: this.$route.query.selectKey,
          type: String(index),
        },
      });
    },
    menuClick(item, isActive) {
      console.log(11111, item, isActive);
      switch (item.name) {
        case "Select":
          if (isActive == "") {
            this.selectList = [];
            // this.onSelectionChange([]);
            // this.$refs.tableRefCompany.clearSelection();
          }
          break;
      }
    },
    // 发送邮件
    onSendEmail(list) {
      this.emailDialogVisible = true;
    },
    // 认证
    onBatch(list) {
      this.batchDialogVisible = true;
    },
    // 添加客户
    onAddCus(list) {
      this.addlDialogVisible = true;
    },
    // ai邮件
    onAi(list) {
      this.aiDialogVisible = true;
    },
    // 打开上传
    openUpload() {
      this.UpdateFileDialog = true;
    },
    // 关闭上传
    onCloseUpDownDialog() {
      this.UpdateFileDialog = false;
    },
    // 上传确认后后跳转到我的数据
    onUploadSuccess() {
      this.$router.push({
        path: "/account/companiesViewed",
        query: {
          type: 4,
        },
      });
    },
    handleCheckAllChange(val) {
      this.treeData.forEach((ele) => {
        if (ele.isChosen == true) {
          ele.children.forEach((element) => {
            if (val) {
              element.ischeck = true;
            } else {
              element.ischeck = false;
            }
          });
        }
      });
      this.checkSelect = this.treeData
        .flatMap((item) => item.children)
        .filter((item) => item.ischeck == true);
    },
    handleCheckedChange(val) {
      this.checkSelect = this.treeData
        .flatMap((item) => item.children)
        .filter((item) => item.ischeck == true);
    },
    chosenGroup(item) {
      this.treeData.forEach((ele) => {
        if (item.id == ele.id) {
          ele.isChosen = true;
        } else {
          ele.isChosen = false;
        }
      });
    },
    delChosen(item) {
      item.ischeck = false;
      this.checkSelect = this.treeData
        .flatMap((item) => item.children)
        .filter((item) => item.ischeck == true);
    },

    // 发邮件确认
    emailConfirm() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          this.emailConfirmDialogVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    this.getCompanyInfo().then(() => {
      // tab 左右切换按钮状态 修复 通过监听 tab滑动style变化来触发状态更新***********
      this.$nextTick(() => {
        const nav = this.$el.querySelector(".el-tabs__nav");
        if (!nav) return;
        this.observer = new MutationObserver(() => {
          const prevButton = this.$el.querySelector(".el-tabs__nav-prev");
          const nextButton = this.$el.querySelector(".el-tabs__nav-next");
          if (prevButton && nextButton) {
            const transformValue = nav.style.transform;

            if (transformValue === "translateX(0px)") {
              prevButton.classList.add("is-disabled");
              nextButton.classList.remove("is-disabled");
            } else {
              prevButton.classList.remove("is-disabled");
              nextButton.classList.add("is-disabled");
            }
          }
        });
        this.observer.observe(nav, {
          attributes: true,
          attributeFilter: ["style"],
        });
      });
      // ***********************************************************************
    });

    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);

    // 页面销毁时 解除监听tab切换*************************************************
    this.observer && this.observer.disconnect();
    // *************************************************************************
  },
};
</script>
<style scoped>
.contact .page-top-con {
  background: #8e86dd !important;
}
.contact .header_menu_box {
  box-shadow: 0px 2px 4px 0px rgba(109, 133, 144, 0.3) !important;
}
.contact .header_menu_box >>> .tollbar-con-filter-btn {
  background: #8e86dd !important;
}
.new-content-top-right {
  min-width: 326px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.new-content-right-company,
.new-content-right-country {
  width: 124px;
  height: auto;
}
.new-content-right-echart {
  width: 100%;
  height: 62px;
  margin-bottom: 8px;
}
.new-content-right-title {
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 16px;
  color: #ffffff;
  white-space: nowrap;
}
.new-content-right-title i {
  margin-left: 6px;
  font-size: 20px;
  color: #ffc800;
  cursor: pointer;
}
.detail_tab_item.active {
  color: #8e86dd;
}
.detail_content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detail_content_tab_content {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detail_content_tab_con_echart {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.dialog_modal >>> .el-dialog__body {
  padding-top: 0;
}
.dialog_modal .dialog_content_body {
  flex: 1;
  overflow: auto;
  padding-left: 6px;
  padding-right: 6px;
  margin-bottom: 20px;
  width: 100%;
}

.batch_title {
  margin-top: 20px;
  margin-bottom: 20px;
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1a2332;
  line-height: 23px;
  text-align: left;
}
.radio_tips {
  margin-left: 26px;
  margin-top: 14px;
  margin-bottom: 30px;
  font-size: 20px;
  color: #666666;
  line-height: 30px;
  text-align: left;
  font-style: normal;
}
.radio_tips .el-button.el-button--text {
  padding: 0;
  font-size: 20px;
  color: #8e86dd;
  line-height: 20px;
}
.radio_tips .el-button + .el-button {
  margin-left: 40px;
}
.dialog_content_body >>> .el-radio {
  justify-content: flex-start;
}
.dialog_content_body >>> .el-radio .el-radio__label {
  font-family: "Arial Bold";
  font-size: 20px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
}
.dialog_content_body >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #685ed1;
}
.dialog_content_body >>> .el-radio__input.is-checked .el-radio__inner::after {
  background-color: #685ed1;
}
.dialog_content_body >>> .icon-shanchu {
  cursor: pointer;
  font-size: 28px;
  color: #f56b6b;
}
.dialog_footer button + button {
  margin-left: 20px;
}
.dialog_footer .risk_cancel_btn {
  background: #e7e5ff;
  color: #685ed1;
}
.dialog_footer .risk_primary_btn {
  background: #8e86dd;
}
.tree_select_box {
  width: 100%;
  display: flex;
  gap: 10px;
  height: 478px;
}
.tree_select {
  flex: 1;
  border-radius: 4px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
}

.tree_select_input {
  height: 64px;
  padding: 10px 10px 14px 10px;
}
.tree_select_input >>> .el-input__inner {
  height: auto !important;
  box-sizing: border-box;
  line-height: 40px;
}
.tree_select_content {
  flex: 1;
  display: flex;
  position: relative;
  overflow: hidden;
}
.tree_select_content::after {
  content: "";
  display: block;
  width: 1px;
  height: 100%;
  background: #cccccc;
  position: absolute;
  left: 50%;
}
.tree_select_content_left {
  width: 50%;
  min-width: 0;
  overflow: auto;
}
.tree_select_content_left ul {
  display: flex;
  flex-direction: column;
}
.tree_select_content_left ul li {
  height: 40px;
  padding-left: 20px;
  padding-right: 14px;
  font-size: 18px;
  color: #1a2332;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tree_select_content_left ul li > div {
  flex: 1;
}
.tree_select_content_left ul li.active {
  background: #ffffff;
  color: #8e86dd;
}
.tree_select_content_left ul li.active i {
  color: #8e86dd;
}

.tree_select_content_right {
  width: 50%;
  min-width: 0;
  overflow: auto;
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tree_select_content_right .el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.tree_select_content_right
  >>> .el-checkbox__input.is-checked
  + .el-checkbox__label {
  color: #8e86dd;
}
.tree_select_content_right
  >>> .el-checkbox__input.is-checked
  .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}
.tree_selected {
  width: 280px;
  background: #f5f5f5;
  flex-shrink: 0;
  border-radius: 4px;
  padding: 20px;
  overflow: auto;
}
.tree_selected_title {
  height: 30px;
  font-family: "Arial Bold";
  font-weight: normal;
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
  margin-bottom: 16px;
  text-align: left;
}
.tree_selected ul {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: auto;
}
.tree_selected ul li {
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tree_selected ul li > div {
  flex: 1;
}
.tree_selected ul li i {
  color: #f56b6b;
}
.dialog_content_body .el-form {
  width: 100%;
  display: flex;
  gap: 20px 60px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.dialog_content_body .el-form .el-form-item {
  width: calc(50% - 30px);
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
.dialog_content_body .el-form .el-form-item >>> .el-form-item__label {
  min-width: 164px;
  font-size: 20px;
  color: #1a2332;
  line-height: 26px;
  text-align: left;
  font-style: normal;
}
.dialog_content_body .el-form .el-form-item >>> .el-form-item__content {
  flex: 1;
}
.dialog_content_body .el-form .el-form-item.row {
  width: 100%;
}
.email_confirm_box {
  width: 100%;
  height: auto;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.email_confirm_box_chosen {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.email_confirm_box_chosen li {
  width: auto;
  max-width: 200px;
  padding-left: 20px;
  padding-right: 20px;
  height: 36px;
  line-height: 36px;
  background: #ffffff;
  border-radius: 23px;
  border: 1px solid #cccccc;
  box-sizing: border-box;
  font-size: 20px;
  color: #1a2332;
  text-align: left;
}
.email_confirm_box_form {
  font-size: 20px;
  color: #1a2332;
  line-height: 26px;
  text-align: left;
  font-style: normal;
}
.email_confirm_box_form + .email_confirm_box_form {
  margin-top: 16px;
}
.detail-dqi-tips .detail-dqi-tips-header {
  color: #8e86dd;
}
@media (max-width: 1920px) {
  .new-content-top-right {
    margin-top: 7px;
    min-width: 218px;
  }
  .new-content-right-company,
  .new-content-right-country {
    width: 82px;
  }
  .new-content-right-echart {
    height: 42px;
    margin-bottom: 6px;
  }
  .new-content-right-title {
    line-height: 14px;
    font-size: 12px;
  }
  .new-content-right-title i {
    margin-left: 4px;
    font-size: 14px;
  }
  .new-content-detail-wrap {
    top: 168px;
    padding: 0 14px;
  }

  .batch_title {
    margin-top: 14px;
    margin-bottom: 14px;
    font-size: 16px;
    line-height: 16px;
  }
  .radio_tips {
    margin-left: 26px;
    margin-top: 12px;
    margin-bottom: 22px;
    font-size: 16px;
    line-height: 22px;
  }
  .radio_tips .el-button.el-button--text {
    font-size: 16px;
    line-height: 16px;
  }
  .radio_tips .el-button + .el-button {
    margin-left: 30px;
  }
  .dialog_modal .dialog_content_body {
    margin-bottom: 14px;
  }
  .dialog_content_body >>> .el-radio .el-radio__label {
    font-size: 16px;
  }
  .dialog_content_body >>> .icon-shanchu {
    font-size: 22px;
  }
  .dialog_footer button + button {
    margin-left: 14px;
  }

  .tree_select_box {
    gap: 8px;
    height: 350px;
  }

  .tree_select_input {
    height: 48px;
    padding: 7px 7px 10px 7px;
  }
  .tree_select_input >>> .el-input__inner {
    line-height: 30px;
  }
  .tree_select_content_left ul li {
    height: 30px;
    padding-left: 14px;
    padding-right: 10px;
    font-size: 14px;
    line-height: 30px;
  }

  .tree_select_content_right {
    padding: 7px 10px;
    gap: 12px;
  }
  .tree_select_content_right .el-checkbox-group {
    gap: 12px;
  }
  .tree_selected {
    width: 210px;
    padding: 14px;
  }
  .tree_selected_title {
    height: 22px;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 12px;
  }
  .tree_selected ul {
    gap: 8px;
  }
  .tree_selected ul li {
    font-size: 14px;
    line-height: 22px;
  }
  .dialog_content_body .el-form {
    gap: 14px 44px;
  }

  .dialog_content_body .el-form .el-form-item {
    width: calc(50% - 22px);
  }
  .dialog_content_body .el-form .el-form-item >>> .el-form-item__label {
    min-width: 130px;
    font-size: 16px;
    line-height: 20px;
  }

  .email_confirm_box {
    padding: 7px 14px 14px 14px;
    margin-bottom: 8px;
  }
  .email_confirm_box_chosen {
    gap: 8px;
  }
  .email_confirm_box_chosen li {
    max-width: 160px;
    padding-left: 14px;
    padding-right: 14px;
    height: 28px;
    line-height: 28px;
    border-radius: 14px;
    font-size: 16px;
  }
  .email_confirm_box_form {
    font-size: 16px;
    line-height: 20px;
  }
  .email_confirm_box_form + .email_confirm_box_form {
    margin-top: 12px;
  }
}
</style>
